import React from 'react'
import "../styles/app.css"

const ButtonRegistaration = () => {
  return (
   <a href="https://youtube.com/live/qNuBXoPHa3c?feature=share"> 
         <button className='scroll__btn'>
            Трансляція 
        </button>
    </a>
  )
}

export default ButtonRegistaration
